export const PHONE = "01 XX XX XX XX";
export const EMAIL = "contact@updiag.fr";
export const ADDRESS = "Paris & Île-de-France";

export const services = [
  {
    id: "dpe",
    slug: "dpe",
    name: "DPE",
    fullName: "Diagnostic de Performance Énergétique",
    icon: "ri-fire-line",
    badge: "★ Service phare",
    featured: true,
    price: "Dès 130 €",
    description: "Obligatoire pour toute vente ou location, le DPE évalue la consommation énergétique de votre bien.",
    points: ["Validité 10 ans", "Rapport le jour même", "Certifié COFRAC"],
  },
  {
    id: "pack-vente",
    slug: "pack-vente",
    name: "Pack Vente",
    fullName: "Dossier de Diagnostic Technique (DDT)",
    icon: "ri-home-2-line",
    badge: null,
    featured: false,
    price: "Dès 280 €",
    description: "Tous les diagnostics obligatoires pour la vente de votre bien immobilier réunis en un seul rendez-vous.",
    points: ["DPE + Amiante + Plomb", "Électricité + Gaz", "Rapport complet"],
  },
  {
    id: "pack-location",
    slug: "pack-location",
    name: "Pack Location",
    fullName: "Diagnostics obligatoires pour la location",
    icon: "ri-key-2-line",
    badge: null,
    featured: false,
    price: "Dès 180 €",
    description: "L'ensemble des diagnostics requis pour mettre votre bien en location en toute conformité.",
    points: ["DPE + Plomb + Électricité", "Gaz si applicable", "Rapport immédiat"],
  },
  {
    id: "amiante",
    slug: "amiante",
    name: "Amiante",
    fullName: "Diagnostic Amiante",
    icon: "ri-shield-check-line",
    badge: null,
    featured: false,
    price: "Dès 120 €",
    description: "Obligatoire pour les biens construits avant juillet 1997, le diagnostic amiante protège vendeurs et acheteurs.",
    points: ["Avant 1997 obligatoire", "Analyse en laboratoire", "Rapport certifié"],
  },
  {
    id: "plomb",
    slug: "plomb",
    name: "Plomb (CREP)",
    fullName: "Constat de Risque d'Exposition au Plomb",
    icon: "ri-test-tube-line",
    badge: null,
    featured: false,
    price: "Dès 110 €",
    description: "Le CREP est obligatoire pour les logements construits avant 1949 en cas de vente ou location.",
    points: ["Avant 1949 obligatoire", "Mesure fluorescence X", "Résultats immédiats"],
  },
  {
    id: "electricite",
    slug: "electricite",
    name: "Électricité",
    fullName: "Diagnostic Électricité",
    icon: "ri-flashlight-line",
    badge: null,
    featured: false,
    price: "Dès 100 €",
    description: "Obligatoire pour les installations électriques de plus de 15 ans lors d'une vente.",
    points: ["Installations +15 ans", "Norme NF C 16-600", "Rapport détaillé"],
  },
  {
    id: "gaz",
    slug: "gaz",
    name: "Gaz",
    fullName: "Diagnostic Gaz",
    icon: "ri-gas-station-line",
    badge: null,
    featured: false,
    price: "Dès 100 €",
    description: "Obligatoire pour les installations gaz de plus de 15 ans lors d'une vente immobilière.",
    points: ["Installations +15 ans", "Sécurité certifiée", "Rapport immédiat"],
  },
  {
    id: "termites",
    slug: "termites",
    name: "Termites",
    fullName: "Diagnostic Termites",
    icon: "ri-bug-line",
    badge: null,
    featured: false,
    price: "Dès 90 €",
    description: "Obligatoire dans les zones à risque définies par arrêté préfectoral, notamment en Île-de-France.",
    points: ["Zones à risque IDF", "Inspection complète", "Rapport certifié"],
  },
  {
    id: "loi-carrez",
    slug: "loi-carrez",
    name: "Loi Carrez",
    fullName: "Mesurage Loi Carrez",
    icon: "ri-ruler-2-line",
    badge: null,
    featured: false,
    price: "Dès 80 €",
    description: "Obligatoire pour la vente de tout lot en copropriété, le mesurage Carrez garantit la surface exacte.",
    points: ["Copropriété obligatoire", "Précision millimétrique", "Validité illimitée"],
  },
];

export const departments = [
  { code: "75", name: "Paris", slug: "paris-75", villes: ["Paris 1er", "Paris 8e", "Paris 15e", "Paris 20e"] },
  { code: "92", name: "Hauts-de-Seine", slug: "hauts-de-seine-92", villes: ["Boulogne-Billancourt", "Nanterre", "Courbevoie", "Levallois-Perret"] },
  { code: "93", name: "Seine-Saint-Denis", slug: "seine-saint-denis-93", villes: ["Saint-Denis", "Montreuil", "Aubervilliers", "Noisy-le-Grand"] },
  { code: "94", name: "Val-de-Marne", slug: "val-de-marne-94", villes: ["Créteil", "Vincennes", "Vitry-sur-Seine", "Ivry-sur-Seine"] },
  { code: "78", name: "Yvelines", slug: "yvelines-78", villes: ["Versailles", "Saint-Germain-en-Laye", "Mantes-la-Jolie", "Poissy"] },
  { code: "91", name: "Essonne", slug: "essonne-91", villes: ["Évry-Courcouronnes", "Massy", "Palaiseau", "Corbeil-Essonnes"] },
  { code: "77", name: "Seine-et-Marne", slug: "seine-et-marne-77", villes: ["Meaux", "Melun", "Chelles", "Pontault-Combault"] },
  { code: "95", name: "Val-d'Oise", slug: "val-d-oise-95", villes: ["Cergy", "Argenteuil", "Sarcelles", "Pontoise"] },
];

export const testimonials = [
  {
    id: 1,
    name: "Sophie M.",
    location: "Paris 15e",
    type: "Appartement 3 pièces",
    rating: 5,
    text: "Intervention rapide et professionnelle pour mon DPE avant vente. Le diagnostiqueur est arrivé à l'heure, a tout expliqué clairement et j'ai reçu mon rapport le soir même. Je recommande vivement Up Diag !",
    avatar: "/img/readdy/t1.jpg",
  },
  {
    id: 2,
    name: "Thomas B.",
    location: "Boulogne-Billancourt (92)",
    type: "Maison 5 pièces",
    rating: 5,
    text: "Pack vente complet réalisé en une seule visite. Très efficace, tarif transparent annoncé dès le devis. Le rapport était parfaitement rédigé pour mon notaire. Merci à toute l'équipe !",
    avatar: "/img/readdy/t2.jpg",
  },
  {
    id: 3,
    name: "Marie-Claire D.",
    location: "Vincennes (94)",
    type: "Studio en location",
    rating: 5,
    text: "J'avais besoin d'un DPE et d'un diagnostic plomb en urgence pour ma mise en location. Up Diag a pu intervenir le lendemain matin. Service impeccable, je ferai appel à eux pour mes prochains biens.",
    avatar: "/img/readdy/t3.jpg",
  },
];

export const faqItems = [
  {
    q: "Quels diagnostics sont obligatoires pour vendre à Paris ?",
    a: "Pour vendre un bien à Paris, vous devez fournir un Dossier de Diagnostic Technique (DDT) comprenant : DPE, diagnostic amiante (avant 1997), CREP plomb (avant 1949), diagnostic électricité (+15 ans), diagnostic gaz (+15 ans), état des risques et pollutions (ERP), et mesurage Loi Carrez pour les copropriétés.",
  },
  {
    q: "Combien de temps dure un diagnostic immobilier ?",
    a: "La durée varie selon le type de diagnostic et la surface du bien. Un DPE seul prend environ 1h à 2h. Un pack vente complet pour un appartement de 3 pièces dure généralement 2h à 3h. Vous recevez votre rapport le jour même par email.",
  },
  {
    q: "Quelle est la validité d'un DPE ?",
    a: "Le DPE a une validité de 10 ans depuis la réforme de juillet 2021. Attention : les DPE réalisés avant le 1er janvier 2018 ne sont plus valides depuis le 1er janvier 2023. Ceux réalisés entre 2018 et 2021 ont expiré le 31 décembre 2024.",
  },
  {
    q: "Intervenez-vous dans toute l'Île-de-France ?",
    a: "Oui, Up Diag intervient dans les 8 départements d'Île-de-France : Paris (75), Hauts-de-Seine (92), Seine-Saint-Denis (93), Val-de-Marne (94), Yvelines (78), Essonne (91), Seine-et-Marne (77) et Val-d'Oise (95). Nous pouvons intervenir sous 48h dans toute la région.",
  },
  {
    q: "Comment obtenir un devis rapidement ?",
    a: "Remplissez notre formulaire en ligne en 2 minutes : indiquez le type de bien, sa surface, son année de construction et votre commune. Vous recevez votre devis personnalisé immédiatement par email. Vous pouvez aussi nous appeler directement au 01 XX XX XX XX.",
  },
  {
    q: "Vos diagnostiqueurs sont-ils certifiés ?",
    a: "Tous nos diagnostiqueurs sont certifiés par des organismes accrédités COFRAC (Comité Français d'Accréditation). Ils disposent des certifications obligatoires pour chaque type de diagnostic (DPE, amiante, plomb, électricité, gaz). Nous sommes également couverts par une assurance RC Pro.",
  },
];

export const blogPosts = [
  {
    id: 1,
    slug: "dpe-2025-changements-paris",
    title: "DPE 2025 : ce qui change pour les propriétaires parisiens",
    excerpt: "La réforme du DPE continue d'évoluer en 2025. Découvrez les nouvelles obligations pour les propriétaires à Paris et en Île-de-France.",
    category: "DPE",
    date: "12 mars 2025",
    readTime: "8 min",
    image: "/img/readdy/b1.jpg",
  },
  {
    id: 2,
    slug: "diagnostics-obligatoires-vente-paris",
    title: "Quels diagnostics obligatoires pour vendre à Paris ?",
    excerpt: "Avant de mettre votre bien en vente à Paris, vous devez constituer un dossier de diagnostic technique complet. Voici tout ce qu'il faut savoir.",
    category: "Vente",
    date: "5 mars 2025",
    readTime: "6 min",
    image: "/img/readdy/b2.jpg",
  },
  {
    id: 3,
    slug: "cout-dpe-paris-2025",
    title: "Combien coûte un DPE à Paris en 2025 ?",
    excerpt: "Le prix d'un DPE à Paris varie selon la surface et le type de bien. Découvrez nos tarifs transparents et ce qui est inclus dans notre prestation.",
    category: "Tarifs",
    date: "28 février 2025",
    readTime: "5 min",
    image: "/img/readdy/b3.jpg",
  },
];

export const pricingTable = [
  { service: "DPE seul", description: "Studio / T1 (< 35 m²)", price: "130 €", highlight: true },
  { service: "DPE seul", description: "T2-T3 (35-80 m²)", price: "150 €", highlight: true },
  { service: "DPE seul", description: "T4+ / Maison (> 80 m²)", price: "180 €", highlight: true },
  { service: "Diagnostic Amiante", description: "Avant 1997 — toute surface", price: "120 €", highlight: false },
  { service: "Plomb (CREP)", description: "Avant 1949 — toute surface", price: "110 €", highlight: false },
  { service: "Diagnostic Électricité", description: "Installation +15 ans", price: "100 €", highlight: false },
  { service: "Diagnostic Gaz", description: "Installation +15 ans", price: "100 €", highlight: false },
  { service: "Diagnostic Termites", description: "Zone à risque IDF", price: "90 €", highlight: false },
  { service: "Loi Carrez", description: "Copropriété — toute surface", price: "80 €", highlight: false },
  { service: "Pack Vente", description: "DDT complet (DPE + 5 diagnostics)", price: "Dès 280 €", highlight: false },
  { service: "Pack Location", description: "DPE + Plomb + Électricité + Gaz", price: "Dès 180 €", highlight: false },
];
